var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0",class:{ 'box-bordered': !_vm.noBorder, 'p-3': !_vm.noBorder }},[(_vm.title)?_c('div',{staticClass:"font-weight-bold",class:{ 'mb-3': _vm.noSeparator }},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.title && !_vm.noSeparator)?_c('hr'):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }